import './App.css'
import { Routes, Route } from "react-router-dom";
import { BrowserRouter as Router } from "react-router-dom";
import LoginPage from './pages/LoginPage';
import ProtectedRoute from './auth/ProtectedRoute';
import ProductQualityIndex from './components/ProductQualityIndex';
import CreamPercentageIndex from './components/CreamPercentageIndex';
import SieveandMagnetoldplant from './components/SieveandMagnetoldplant';
import ProductMonitoringRecord from './components/ProductMonitoringRecord';
import NetWeightMonitoringRecord from './components/NetWeightMonitoringRecord';
import CodeVerificationRecord from './components/CodeVerification';
import OPRPAndCCPRecord from './components/OPRPAndCCPRecord';
import SealIntegrityTest from './components/SealIntegrityTest';
import ALC from './components/ALC';
import BakingProcessRecord from './components/BakingProcessRecord';
import BakingAndCooling from './components/BakingAndCooling';
import BackingCoding from './components/BackingCoding';
import BackingMixing from './components/BackingMixing';
import ProcessFormat from './components/ProcessFormat';
import Proofing from './components/Proofing';
import BakingSievesAndMagnets from './components/BakingSievesAndMagnets';
import BackingPQI from './components/BackingPQI';
import PlantTourSection from './components/PlantTourSection';
import DashboardLayout from './pages/HomePage';
import SieveandMagnetnewplant from './components/SieveandMagnetnewplant';
import ErrorBoundary from './components/ErrorBoundary';
import QualityWallRecord from './components/QualityWallRecord';
import MixingParameterVerification from './components/MixingParameterVerification';



function App() {

  return (
    <>
      <Router>
        <Routes>
          <Route path="/" element={<LoginPage />} />
          <Route
            path="/home"
            element={
              <ProtectedRoute>
                <DashboardLayout />
              </ProtectedRoute>
            }
          />
          <Route
            path="/qualityplantour"
            element={
              <ProtectedRoute>
                <ProductQualityIndex />
              </ProtectedRoute>
            }
          />
          <Route
            path="/creampercentage"
            element={
              <ProtectedRoute>
                <CreamPercentageIndex />
              </ProtectedRoute>
            }
          />
          <Route
            path="/sieveandmagnetoldplant"
            element={
              <ProtectedRoute>
                <SieveandMagnetoldplant />
              </ProtectedRoute>
            }
          />
          <Route
            path="/sieveandmagnetnewplant"
            element={
              <ProtectedRoute>
                <ErrorBoundary>
                  <SieveandMagnetnewplant />
                </ErrorBoundary>
              </ProtectedRoute>
            }
          />
          <Route
            path="/sieveandmagnetnewplant-debug"
            element={
              <ProtectedRoute>
                <ErrorBoundary>
                  <SieveandMagnetnewplant />
                </ErrorBoundary>
              </ProtectedRoute>
            }
          />
          <Route
            path="/productmonitoringrecord"
            element={
              <ProtectedRoute>
                <ErrorBoundary>
                  <ProductMonitoringRecord />
                </ErrorBoundary>
              </ProtectedRoute>
            }
          />
          <Route
            path="/netweightmonitoringrecord"
            element={
              <ProtectedRoute>
                <ErrorBoundary>
                  <NetWeightMonitoringRecord />
                </ErrorBoundary>
              </ProtectedRoute>
            }
          />
          <Route
            path="/codeverificationrecord"
            element={
              <ProtectedRoute>
                <ErrorBoundary>
                  <CodeVerificationRecord />
                </ErrorBoundary>
              </ProtectedRoute>
            }
          />
          <Route
            path="/oprpandccprecord"
            element={
              <ProtectedRoute>
                  <ErrorBoundary>
                    <OPRPAndCCPRecord />
                  </ErrorBoundary>
              </ProtectedRoute>
            }
          />
          <Route
            path="/bakingprocessrecord"
            element={
              <ProtectedRoute>
                  <ErrorBoundary>
                    <BakingProcessRecord />
                  </ErrorBoundary>
              </ProtectedRoute>
            }
          />
          <Route
            path="/bakingandcooling"
            element={
              <ProtectedRoute>
                  <ErrorBoundary>
                    <BakingAndCooling />
                  </ErrorBoundary>
              </ProtectedRoute>
            }
          />
          <Route
            path="/backingcoding"
            element={
              <ProtectedRoute>
                <ErrorBoundary>
                  <BackingCoding />
                </ErrorBoundary>
              </ProtectedRoute>
            }
          />
          <Route
            path="/backingmixing"
            element={
              <ProtectedRoute>
                <ErrorBoundary>
                  <BackingMixing />
                </ErrorBoundary>
              </ProtectedRoute>
            }
          />
          <Route
            path="/processformat"
            element={
              <ProtectedRoute>
                <ErrorBoundary>
                  <ProcessFormat />
                </ErrorBoundary>
              </ProtectedRoute>
            }
          />
          <Route
            path="/proofing"
            element={
              <ProtectedRoute>
                <ErrorBoundary>
                  <Proofing />
                </ErrorBoundary>
              </ProtectedRoute>
            }
          />
          <Route
            path="/bakingsievesandmagnets"
            element={
              <ProtectedRoute>
                <ErrorBoundary>
                  <BakingSievesAndMagnets />
                </ErrorBoundary>
              </ProtectedRoute>
            }
          />
          <Route
            path="/backing-pqi"
            element={
              <ProtectedRoute>
                <ErrorBoundary>
                  <BackingPQI />
                </ErrorBoundary>
              </ProtectedRoute>
            }
          />
          <Route
            path="/backingpqi"
            element={
              <ProtectedRoute>
                <ErrorBoundary>
                  <BackingPQI />
                </ErrorBoundary>
              </ProtectedRoute>
            }
          />
          <Route
            path="/sealintegritytest"
            element={
              <ProtectedRoute>
                <SealIntegrityTest />
              </ProtectedRoute>
            }
          />
          <Route
            path="/alc"
            element={
              <ProtectedRoute>
                <ALC />
              </ProtectedRoute>
            }
          />
          <Route
            path="/plant-tour-section"
            element={
              <ProtectedRoute>
                <PlantTourSection />
              </ProtectedRoute>
            }
          />
          <Route
            path="/qualitywallrecord"
            element={
              <ProtectedRoute>
                <ErrorBoundary>
                  <QualityWallRecord />
                </ErrorBoundary>
              </ProtectedRoute>
            }
          />
          <Route
            path="/processparameterverification"
            element={
              <ProtectedRoute>
                <ErrorBoundary>
                  <MixingParameterVerification />
                </ErrorBoundary>
              </ProtectedRoute>
            }
          />
        </Routes>
      </Router>
    </>
  )
}

export default App
